import { useCallback, useRef } from 'react';

export const useVideoRefs = () => {
  const refs = useRef<Map<number, HTMLVideoElement>>(new Map());

  const setRef = useCallback(
    (index: number) => (el: HTMLVideoElement | null) => {
      if (el) {
        refs.current.set(index, el);
      } else {
        refs.current.delete(index);
      }
    },
    []
  );

  const getRef = useCallback((index: number): HTMLVideoElement | null => {
    return refs.current.get(index) ?? null;
  }, []);

  const pauseExcept = useCallback((activeIndex: number) => {
    refs.current.forEach((video, index) => {
      if (index !== activeIndex) {
        video.pause();
      }
    });
  }, []);

  return { setRef, getRef, pauseExcept };
};
